import React from 'react';
import { CircularProgress, Typography } from '@mui/material';

/**
 * LoadingSpinner component - displays a centered circular progress indicator with a message
 * @param {Object} props - Component props
 * @param {string} [props.message='Loading...'] - The message to display below the spinner
 * @param {number} [props.size=60] - Size of the circular progress indicator
 * @param {number} [props.thickness=4] - Thickness of the circular progress indicator
 * @param {string} [props.color='#3B82F6'] - Color of the spinner, using the blue-500 color
 */
const LoadingSpinner = ({ 
  message = 'Loading...', 
  size = 60, 
  thickness = 4, 
  color = '#3B82F6' 
}) => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div className="text-center p-8 bg-white rounded-lg shadow-md">
        <CircularProgress size={size} thickness={thickness} sx={{ color, mb: 3 }} />
        <Typography variant="h6" className="text-gray-700 font-medium">
          {message}
        </Typography>
      </div>
    </div>
  );
};

export default LoadingSpinner; 